import API from '@/services/endpoint'
import { FETCH_FOOTER} from "../../mutation-types";

/**
 * API Get Request to fetch the footer
 * @param {function} commit - The vuex commit function
 * @param {object} state - The vuex state object
 * @return {object[]} A array of images
 */
export async function fetchFooter({commit, state}) {
  const { url } = state;
  let responseObj = await API.get(url);
  let { data: { message: { footer } } } = responseObj;
  commit(FETCH_FOOTER, footer)
}
